import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/voten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierVoteVote"
      returnRoute="/auswahlfelder/dossierVoteVote"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierVoteVoteRoute = Route;
